"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ExactIcon = ({ className, width = '40', height = '40', onClick, }) => {
    return (react_1.default.createElement("div", { onClick: onClick, role: onClick ? 'button' : undefined },
        react_1.default.createElement(react_1.default.Suspense, { fallback: null },
            react_1.default.createElement("svg", { role: "img", width: width, height: height, viewBox: `0 0 ${width} ${height}`, fill: "currentColor", className: className, xmlns: "http://www.w3.org/2000/svg" },
                react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M31.0003 12.002H8.99902V18.002H31.0003V12.002ZM31.0003 21.9998H8.99902V27.9995H31.0003V21.9998Z", fill: "#E2161F" })))));
};
exports.default = ExactIcon;
//# sourceMappingURL=ExactIcon.js.map